import {
    ElementRef,
    Renderer2,
    OnInit,
    Input,
    Component,
    OnChanges,
    SimpleChanges,
    SimpleChange
} from '@angular/core';
import { TreeService } from './tree.service';
import * as _ from 'lodash';

@Component({
    selector: '[checkbox-tree]',
    styleUrls: ['./checkbox-tree.component.scss'],
    templateUrl: './checkbox-tree.component.html'
})
export class CheckBoxTreeComponent implements OnChanges, OnInit {
    @Input('checkbox-tree') checkboxTree: any;
    @Input() expand: Function;
    @Input() change: Function;
    @Input() disabled: any;
    @Input() rowDirective: any;
    @Input() rowDirectiveLevels: any;

    constructor(
        private elem: ElementRef,
        private treeService: TreeService,
        private renderer: Renderer2
    ) { }

    private rootContainer: any = this.elem.nativeElement;
    public tree: any = [];
    public checkedStateForIndeterminate: boolean = false;
    public treeDisabled: boolean;

    ngOnChanges(changes: SimpleChanges): void {
        const checkBoxTreeChange: SimpleChange = changes.checkboxTree;
        const disabledChange: SimpleChange = changes.disabled;
        if (checkBoxTreeChange) {
            this.onCheckBoxTreeChange(checkBoxTreeChange.currentValue);
        }
        if (disabledChange) {
            this.onCheckBoxDisabled(disabledChange.currentValue);
        }
    }

    ngOnInit(): void {
        this.renderer.addClass(this.rootContainer, 'checkbox-tree');
        this.checkedStateForIndeterminate = this.getCheckedStateForIndeterminate();
    }

    public expandItem(event, item): void {
        if (item) {
            item.expanded = true;
            this.toggleChildren(event, true);
            this.expand(item);
        }
    }

    public collapseItem(event, item): void {
        if (item) {
            item.expanded = false;
            this.toggleChildren(event, false);
        }
    }

    public selectItem(event, item): void {
        const elem = event.target;
        const checkBoxStatus = elem.checked;
        this.treeService.change(item, checkBoxStatus);
        this.treeService.reloadAttrs.call(this.treeService, this.tree);
        this.change(item);
    }

    private toggleChildren(event, status): void {
        const elem = event.target.closest('.checkbox-tree-item');
        this.renderer.removeClass(elem, 'expanded');
        if (status) {
            this.renderer.addClass(elem, 'expanded');
        }
    }

    private getCheckedStateForIndeterminate(): boolean {
        // Create a unchecked checkbox with indeterminate state
        const test = document.createElement('input');
        test.type = 'checkbox';
        test.checked = false;
        test.indeterminate = true;

        const body = document.body;
        body.appendChild(test);
        test.click();
        body.removeChild(test);

        return !test.checked;
    }

    private onCheckBoxTreeChange(data): void {
        this.tree = data;
        if (!_.isArray(this.tree)) {
            this.tree = [];
        }

        if (this.rootContainer.querySelector('.checkbox-tree-item')) {
            this.rootContainer.querySelector('.checkbox-tree-item').remove();
        }
        this.treeService.reloadAttrs(this.tree);
        this.change();
    }

    private onCheckBoxDisabled(disabled): void {
        this.treeDisabled = disabled;
        this.treeService.reloadAttrs(this.tree);
        // this method to diabled the directive should be better
        this.tree.forEach(item => {
            item.directiveDisabled = disabled;
        });
    }
}
